import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';

import * as firebase from 'firebase'; // TODO: update to only use 'firebase/auth'
import * as moment from 'moment';

import { PrivacyPage } from '../../pages/privacy/privacy';
import { TermsPage } from '../../pages/terms/terms';
import { HomePage } from '../../pages/home/home';

import { AuthProvider } from '../../providers/auth/auth';
import { WindowProvider } from '../../providers/window/window';
import { StaffProvider } from '../../providers/staff/staff';

import { IStaffUser } from '../../interfaces/users';
import { IStaffType } from './../../interfaces/staff';
import { IMonth, IDate } from './../../interfaces/dates';

@Component({
  selector: 'page-register-staff',
  templateUrl: 'register-staff.html'
})
export class RegisterStaffPage implements OnInit, OnDestroy {
  fbUser: any;
  providerId: string;
  windowRef: any;
  registerForm: FormGroup;
  verificationForm: FormGroup;
  isConfirmed = false;
  days = [];
  months = [];
  years = [];
  staffTypes: Array<IStaffType> = [];
  staffTypeSubscription: Subscription;
  staffTypeDataLoaded = false;

  provinces: Array<string> = [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North West",
    "Western Cape",
  ];

  // TODO: pull cellphone number through from initial phone auth on login... if that is what the user did

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private authProvider: AuthProvider,
    private staffProvider: StaffProvider,
    private win: WindowProvider
  ) {
    this.registerForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      email: [''],
      cellphone: [''],
      idNo: [''],
      gender: [''],
      dobDay: [''],
      dobMonth: [''],
      dobYear: [''],
      preferredJobType: [''],
      province: [''],
    });
    this.verificationForm = this.formBuilder.group({
      verificationCode: ['']
    });

    for (let i = 1; i < 32; i++) {
      this.days.push(i);
    }

    for (let i = 1; i < 13; i++) {
      let name: string;
      switch (i) {
        case 1: {
          name = 'January';
          break;
        }
        case 2: {
          name = 'February';
          break;
        }
        case 3: {
          name = 'March';
          break;
        }
        case 4: {
          name = 'April';
          break;
        }
        case 5: {
          name = 'May';
          break;
        }
        case 6: {
          name = 'June';
          break;
        }
        case 7: {
          name = 'July';
          break;
        }
        case 8: {
          name = 'August';
          break;
        }
        case 9: {
          name = 'September';
          break;
        }
        case 10: {
          name = 'October';
          break;
        }
        case 11: {
          name = 'November';
          break;
        }
        case 12: {
          name = 'December';
          break;
        }
        default: {
          //statements;
          break;
        }
      }
      const month: IMonth = {
        month: this.padLeft(i.toString(), '0', 2),
        name: name
      };
      this.months.push(month);
    }

    let currentYear = new Date().getFullYear();
    let minYear = currentYear - 18;
    for (let i = 1950; i < minYear + 1; i++) {
      this.years.push(i);
    }
    this.years.reverse();
  }

  ngOnInit() {
    const self = this;
    self.authProvider.getFbUser().then(fbUser => {
      self.fbUser = fbUser;
      if (self.fbUser !== null) {
        console.log(self.fbUser.providerData[0].providerId);
        self.providerId = self.fbUser.providerData[0].providerId;
        if (self.fbUser.phoneNumber) {
          let phoneNumber = self.fbUser.phoneNumber.replace('+27', '0');
          self.registerForm.controls.cellphone.setValue(phoneNumber);
        }
      } else {
        console.log(fbUser);
        self.windowRef = self.win.windowRef;
        self.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          'recaptchaContainerRegister'
        );
        self.windowRef.recaptchaVerifier.render();
      }
    });
    this.loadStaffTypes();
  }

  ngOnDestroy() {
    if (this.staffTypeSubscription) {
      this.staffTypeSubscription.unsubscribe();
    }
  }

  ionViewDidLoad() {
    // TODO: add analytics
  }

  loadStaffTypes() {
    this.staffTypeSubscription = this.staffProvider.getStaffTypes().subscribe(staff => {
      console.log(staff);
      this.staffTypes = staff;
      this.staffTypeDataLoaded = true;
      return staff;
    });
  }

  sendLoginCode() {
    const self = this;
    const appVerfier = self.windowRef.recaptchaVerifier;
    const num = `+27${self.registerForm.controls.cellphone.value}`; // TODO: create a service/method that converts numbers enetered into correct format

    console.log(self.registerForm.value);
    // TODO: check if the register form is valid
    firebase
      .auth()
      .signInWithPhoneNumber(num, appVerfier)
      .then(res => {
        self.windowRef.confirmationResult = res;
        self.isConfirmed = true;
      })
      .catch(err => {
        console.log(err);
      });
  }

  verifyLoginCode() {
    const self = this;
    self.windowRef.confirmationResult
      .confirm(self.verificationForm.controls.verificationCode.value)
      .then(res => {
        console.log(res);
        self.providerId = 'phone';
        self.createProfile(res.user.uid);
      })
      .catch(err => {
        console.log(err);
      });
  }

  createProfile(uid: string) {
    console.log(uid);
    const self = this;
    let birthdate: IDate = {
      day: self.registerForm.value.dobDay,
      month: self.registerForm.value.dobMonth,
      year: self.registerForm.value.dobYear
    };

    let paddedDay = self.padLeft(birthdate.day.toString(), '0', 2);
    let dob = `${birthdate.year}${birthdate.month}${paddedDay}`;

    let user: IStaffUser = {
      uid: uid,
      firstName: self.registerForm.value.firstName,
      lastName: self.registerForm.value.lastName,
      email: self.registerForm.value.email,
      cellphone: self.registerForm.value.cellphone,
      idNo: self.registerForm.value.idNo,
      gender: self.registerForm.value.gender,
      birthdate: moment(`${dob}`, 'YYYYMMDD').format(),
      preferredJobType: self.registerForm.value.preferredJobType,
      regType: 'staff',
      provider: self.providerId
    };
    self.authProvider
      .createStaffUser(user)
      .then(() => {
        var OneSignal = window['OneSignal'] || [];
        OneSignal.push(function() {
          OneSignal.sendTag('regType', 'staff');
        });

        location.reload();
      })
      .catch(err => {
        console.log(err);
      });
  }

  openPage(page: string) {
    const self = this;
    switch (page) {
      case 'privacy': {
        self.navCtrl.push(PrivacyPage);
        break;
      }
      case 'terms': {
        self.navCtrl.push(TermsPage, { regType: 'staff' });
        break;
      }
    }
  }

  // TODO: create a utility service and stick this in there
  // Utility function
  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-staff/register-staff.ts